export enum FilterTypes {
  MULTI_SELECT = "MULTI_SELECT",
  TEXT = "TEXT",
  DATE = "DATE",
  TIME = "TIME",
}
